{
	"EmailRule_Failed": "Email must be valid",
	"NAME": "GenericRuleLanguage"
}